import React, { useState, useEffect, useCallback } from 'react';
import './dat_clientes.css';
import apiServices from '../../../../actions/services';
import { useSelector } from 'react-redux';
import TourGuia from '../../../../../componentes/TourGuia';

// Componente de protección de contenido
const ContentProtector = ({ children }) => {
  useEffect(() => {
    // Prevenir shortcuts de copia y captura
    const handleKeyDown = (event) => {
      // Ctrl+C, Ctrl+Insert, Cmd+C
      if ((event.ctrlKey || event.metaKey) && 
          (event.key === 'c' || event.key === 'C' || event.keyCode === 67)) {
        event.preventDefault();
        alert('La copia de contenido está deshabilitada');
        return false;
      }
      
      // Print Screen y variantes
      if (event.keyCode === 44 || 
          event.key === 'PrintScreen' ||
          (event.ctrlKey && event.key === 'PrintScreen') || 
          (event.altKey && event.key === 'PrintScreen')) {
        event.preventDefault();
        alert('Las capturas de pantalla están deshabilitadas');
        return false;
      }

      // Windows + Shift + S (snipping tool)
      if (event.key === 's' && event.shiftKey && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        alert('Las capturas de pantalla están deshabilitadas');
        return false;
      }
    };

    // Prevenir clic derecho (menú contextual)
    const handleContextMenu = (event) => {
      event.preventDefault();
      alert('El menú contextual está deshabilitado');
    };

    // Prevenir arrastrar imágenes
    const handleDragStart = (event) => {
      event.preventDefault();
    };

    // Detectar intentos de captura en móviles
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Posible screenshot detectado - cambio de visibilidad');
      }
    };

    // Prevenir selección de texto
    const handleSelectStart = (event) => {
      event.preventDefault();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('selectstart', handleSelectStart);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('selectstart', handleSelectStart);
    };
  }, []);

  const handleCopy = (event) => {
    event.preventDefault();
    alert('La copia de contenido está deshabilitada');
  };

  const handleCut = (event) => {
    event.preventDefault();
    alert('El corte de contenido está deshabilitado');
  };

  const handlePaste = (event) => {
    event.preventDefault();
    alert('La pega está deshabilitada');
  };

  return (
    <div 
      onCopy={handleCopy}
      onCut={handleCut}
      onPaste={handlePaste}
      onContextMenu={(e) => e.preventDefault()}
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        WebkitTouchCallout: 'none'
      }}
      className="protected-content no-select"
    >
      {children}
    </div>
  );
};

const DatosClientes = () => {
  const { user } = useSelector(state => state.auth);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    CardCode: '',
    CardName: '',
    Contacto: '',
    Tel1_C: '',
    TIPO_PEDIDO_DESC: '',
    Forma_Pago:'',
    Territorio:'',
    CONDICION_PAGO:'',
    DIST:''
  });
  const [columns, setColumns] = useState([
    { key: 'CardCode', label: 'Código', visible: true, order: 0 },
    { key: 'CardName', label: 'Nombre', visible: true, order: 1 },
    { key: 'Contacto', label: 'Contacto', visible: true, order: 2 },
    { key: 'Tel1_C', label: 'Teléfono 1', visible: true, order: 3 },
    { key: 'Tel2_C', label: 'Teléfono 2', visible: true, order: 4 },
    { key: 'email1_C', label: 'Email 1', visible: true, order: 5 },
    { key: 'email2_C', label: 'Email 2', visible: true, order: 6 },
    { key: 'TIPO_PEDIDO_DESC', label: 'Tipo Pedido', visible: true, order: 7 },
    { key: 'Forma_Pago', label: 'Forma de Pago', visible: true, order: 8 },
    { key: 'Territorio', label: 'Territorio', visible: true, order: 9 },
    { key: 'CONDICION_PAGO', label: 'Condicion Pago', visible: true, order: 10 },
    { key: 'DIST', label: 'Distribuidora', visible: true, order: 11 }
  ]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [draggedColumn, setDraggedColumn] = useState(null);
  const [mostrarTour, setMostrarTour] = useState(false);

  // Configuración del tour - CORREGIDO según la estructura de EstructuraAPI
  const pasosTour = [
    {
      selector: '.filters-section',
      titulo: '🔍 Panel de Filtros de Clientes',
      contenido: 'En esta sección puedes filtrar los clientes por diferentes criterios como código, nombre, contacto, teléfono o tipo de pedido. Usa los campos para refinar tu búsqueda.',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#007bff',
      colorFondo: 'rgba(0, 123, 255, 0.1)',
      animacion: 'brillo-azul',
      boxShadow: '0 0 0 4px #007bff, 0 0 30px rgba(0, 123, 255, 0.8)'
    },
    {
      selector: 'input[name="CardCode"]',
      titulo: '📋 Filtrar por Código',
      contenido: 'Busca clientes específicos ingresando su código único. Ejemplo: CLIE00001. El sistema buscará coincidencias exactas o parciales.',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#28a745',
      colorFondo: 'rgba(40, 167, 69, 0.1)',
      animacion: 'brillo-verde',
      boxShadow: '0 0 0 4px #28a745, 0 0 30px rgba(40, 167, 69, 0.8)'
    },
    {
      selector: 'input[name="CardName"]',
      titulo: '🏢 Filtrar por Nombre',
      contenido: 'Encuentra clientes por su nombre comercial o razón social. Ejemplo: "Supertienda Paiz". La búsqueda es sensible a mayúsculas y minúsculas.',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#6f42c1',
      colorFondo: 'rgba(111, 66, 193, 0.1)',
      animacion: 'brillo-purpura',
      boxShadow: '0 0 0 4px #6f42c1, 0 0 30px rgba(111, 66, 193, 0.8)'
    },
    {
      selector: 'input[name="Contacto"]',
      titulo: '👤 Filtrar por Contacto',
      contenido: 'Busca por el nombre de la persona de contacto del cliente. Ejemplo: "Ana Victoria Castillo". Útil para encontrar contactos específicos.',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#fd7e14',
      colorFondo: 'rgba(253, 126, 20, 0.1)',
      animacion: 'brillo-naranja',
      boxShadow: '0 0 0 4px #fd7e14, 0 0 30px rgba(253, 126, 20, 0.8)'
    },
    {
      selector: 'input[name="Tel1_C"]',
      titulo: '📞 Filtrar por Teléfono',
      contenido: 'Localiza clientes por su número telefónico principal. Ejemplo: 56850122. Puedes buscar por partes del número.',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#17a2b8',
      colorFondo: 'rgba(23, 162, 184, 0.1)',
      animacion: 'brillo-azul',
      boxShadow: '0 0 0 4px #17a2b8, 0 0 30px rgba(23, 162, 184, 0.8)'
    },
    {
      selector: 'input[name="TIPO_PEDIDO_DESC"]',
      titulo: '📦 Filtrar por Tipo de Pedido',
      contenido: 'Filtra según el tipo de pedido asociado al cliente (ej: Visita, Telefónico, etc.). Ayuda a segmentar por canal de venta.',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#e83e8c',
      colorFondo: 'rgba(232, 62, 140, 0.1)',
      animacion: 'brillo-purpura',
      boxShadow: '0 0 0 4px #e83e8c, 0 0 30px rgba(232, 62, 140, 0.8)'
    },
    {
      selector: '.filter-buttons',
      titulo: '⚡ Acciones de Filtros',
      contenido: '<strong>Buscar</strong>: Aplica los filtros configurados<br><strong>Limpiar Filtros</strong>: Elimina todos los filtros activos<br><strong>Actualizar Datos</strong>: Recarga la información desde el servidor',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#007bff',
      colorFondo: 'rgba(0, 123, 255, 0.1)',
      animacion: 'brillo-azul',
      boxShadow: '0 0 0 4px #007bff, 0 0 30px rgba(0, 123, 255, 0.8)'
    },
    {
      selector: '.columns-config',
      titulo: '🎛️ Configuración de Columnas',
      contenido: 'Aquí puedes personalizar tu vista seleccionando qué columnas deseas visualizar. Desmarca las que no necesites para una experiencia más limpia.',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#6f42c1',
      colorFondo: 'rgba(111, 66, 193, 0.1)',
      animacion: 'brillo-purpura',
      boxShadow: '0 0 0 4px #6f42c1, 0 0 30px rgba(111, 66, 193, 0.8)'
    },
    {
      selector: '.table-section',
      titulo: '📊 Tabla de Clientes',
      contenido: 'Esta tabla muestra todos los clientes según los filtros aplicados. Las columnas <strong>Código</strong> y <strong>Nombre</strong> están fijas para mejor navegación.',
      posicion: 'top',
      overlayClic: false,
      colorBorde: '#28a745',
      colorFondo: 'rgba(40, 167, 69, 0.1)',
      animacion: 'brillo-verde',
      boxShadow: '0 0 0 4px #28a745, 0 0 30px rgba(40, 167, 69, 0.8)'
    },
    {
      selector: '.fixed-column, .fixed-column-2',
      titulo: '📌 Columnas Fijas',
      contenido: 'Las columnas <strong>Código</strong> y <strong>Nombre</strong> permanecen visibles durante el scroll horizontal. Siempre podrás identificar qué cliente estás revisando.',
      posicion: 'top',
      overlayClic: false,
      colorBorde: '#fd7e14',
      colorFondo: 'rgba(253, 126, 20, 0.1)',
      animacion: 'brillo-naranja',
      boxShadow: '0 0 0 4px #fd7e14, 0 0 30px rgba(253, 126, 20, 0.8)'
    },
    {
      selector: '.sortable',
      titulo: '🔃 Ordenar Datos',
      contenido: 'Haz clic en cualquier encabezado de columna para ordenar los datos ascendente o descendente. El indicador ↑↓ muestra la dirección actual del ordenamiento.',
      posicion: 'bottom',
      overlayClic: false,
      colorBorde: '#17a2b8',
      colorFondo: 'rgba(23, 162, 184, 0.1)',
      animacion: 'brillo-azul',
      boxShadow: '0 0 0 4px #17a2b8, 0 0 30px rgba(23, 162, 184, 0.8)'
    },
    {
      selector: '.data-table th',
      titulo: '🎯 Arrastrar Columnas',
      contenido: 'Puedes reorganizar las columnas arrastrándolas y soltándolas en la posición que prefieras. ¡Personaliza el orden según tus necesidades de trabajo!',
      posicion: 'top',
      overlayClic: false,
      colorBorde: '#e83e8c',
      colorFondo: 'rgba(232, 62, 140, 0.1)',
      animacion: 'brillo-purpura',
      boxShadow: '0 0 0 4px #e83e8c, 0 0 30px rgba(232, 62, 140, 0.8)'
    },
    {
      selector: '.btn-outline-info',
      titulo: 'ℹ️ Ayuda y Tutorial',
      contenido: '¿Necesitas recordar cómo funciona algo? Siempre puedes volver a ver este tutorial haciendo clic en el botón "Guía Rápida".',
      posicion: 'left',
      overlayClic: false,
      colorBorde: '#17a2b8',
      colorFondo: 'rgba(23, 162, 184, 0.1)',
      animacion: 'latido',
      boxShadow: '0 0 0 4px #17a2b8, 0 0 30px rgba(23, 162, 184, 0.8)'
    }
  ];

  // Función para reiniciar el tour - CORREGIDA
  const reiniciarTour = () => {
    localStorage.removeItem('tourDatosClientes_completado');
    setMostrarTour(true);
  };

  // Efecto para mostrar el tour automáticamente si no se ha completado - CORREGIDO
  useEffect(() => {
    const tourCompletado = localStorage.getItem('tourDatosClientes_completado');
    console.log('Tour completado en localStorage:', tourCompletado);
    
    if (!tourCompletado) {
      console.log('Mostrando tour automáticamente');
      setMostrarTour(true);
    }
  }, []);

  // fetchData con useCallback para evitar dependencia circular - CORREGIDO
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const dat = {"Vista":"DAT_DISTRIBUIDORA","CodUsuario":user.id_usuario};
      const datos = await apiServices.get('ListaReportesVentas', dat, user);
      console.log(datos.datos_Generados);
      const mockData = JSON.parse(datos.datos_Generados);
      setData(mockData);
      setFilteredData(mockData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  // useEffect para fetchData inicial - CORREGIDO
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    const filtered = data.filter(item => {
      return Object.keys(filters).every(key => {
        if (!filters[key]) return true;
        return item[key]?.toString().toLowerCase().includes(filters[key].toLowerCase());
      });
    });
    setFilteredData(filtered);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const handleDragStart = (e, columnIndex) => {
    setDraggedColumn(columnIndex);
  };

  const handleDragOver = (e, targetIndex) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetIndex) => {
    e.preventDefault();
    if (draggedColumn === null || draggedColumn === targetIndex) return;

    const newColumns = [...columns];
    const draggedCol = newColumns[draggedColumn];
    
    // Reordenar columnas
    newColumns.splice(draggedColumn, 1);
    newColumns.splice(targetIndex, 0, draggedCol);
    
    // Actualizar el orden
    const updatedColumns = newColumns.map((col, index) => ({
      ...col,
      order: index
    }));

    setColumns(updatedColumns);
    setDraggedColumn(null);
  };

  const toggleColumnVisibility = (columnKey) => {
    setColumns(columns.map(col => 
      col.key === columnKey ? { ...col, visible: !col.visible } : col
    ));
  };

  const resetFilters = () => {
    setFilters({
      CardCode: '',
      CardName: '',
      Contacto: '',
      Tel1_C: '',
      TIPO_PEDIDO_DESC: '',
      Forma_Pago:'',
      Territorio:'',
      CONDICION_PAGO:'',
      DIST:''
    });
    setFilteredData(data);
  };

  const visibleColumns = columns.filter(col => col.visible).sort((a, b) => a.order - b.order);

  return (
    <ContentProtector>
      <div className="app">
        {/* Encabezado con botón de tour */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h1>Consulta de Clientes</h1>
          {/* <button 
            className="btn btn-sm"
            onClick={reiniciarTour}
            title="Volver a ver el tutorial"
            style={{
              backgroundColor: 'transparent',
              color: '#007bff',
              border: '2px solid #007bff',
              borderRadius: '25px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              padding: '6px 18px',
              marginLeft: 'auto'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#007bff';
              e.target.style.color = 'white';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#007bff';
              e.target.style.transform = 'scale(1)';
            }}
          >
            🎓 Guía Rápida
          </button> */}
        </div>

        {/* Componente del Tour - CORREGIDO */}
        {/* {mostrarTour && (
          <TourGuia 
            pasos={pasosTour} 
            onFinalizar={() => {
              localStorage.setItem('tourDatosClientes_completado', 'true');
              setMostrarTour(false);
            }}
          />
        )} */}

        {/* Sección de Filtros */}
        <div className="filters-section">
          <h2>Filtros</h2>
          <div className="filters-grid">
            <div className="filter-group">
              <label>Código:</label>
              <input
                type="text"
                name="CardCode"
                value={filters.CardCode}
                onChange={handleFilterChange}
                placeholder="Filtrar por código..."
              />
            </div>
            <div className="filter-group">
              <label>Nombre:</label>
              <input
                type="text"
                name="CardName"
                value={filters.CardName}
                onChange={handleFilterChange}
                placeholder="Filtrar por nombre..."
              />
            </div>
            <div className="filter-group">
              <label>Contacto:</label>
              <input
                type="text"
                name="Contacto"
                value={filters.Contacto}
                onChange={handleFilterChange}
                placeholder="Filtrar por contacto..."
              />
            </div>
            <div className="filter-group">
              <label>Teléfono:</label>
              <input
                type="text"
                name="Tel1_C"
                value={filters.Tel1_C}
                onChange={handleFilterChange}
                placeholder="Filtrar por teléfono..."
              />
            </div>
            <div className="filter-group">
              <label>Tipo Pedido:</label>
              <input
                type="text"
                name="TIPO_PEDIDO_DESC"
                value={filters.TIPO_PEDIDO_DESC}
                onChange={handleFilterChange}
                placeholder="Filtrar por tipo..."
              />
            </div>
            <div className="filter-group">
              <label>Territorio:</label>
              <input
                type="text"
                name="Territorio"
                value={filters.Territorio}
                onChange={handleFilterChange}
                placeholder="Filtrar por código..."
              />
            </div>
            <div className="filter-group">
              <label>Distribuidora:</label>
              <input
                type="text"
                name="DIST"
                value={filters.DIST}
                onChange={handleFilterChange}
                placeholder="Filtrar por código..."
              />
            </div>
          </div>
          <div className="filter-buttons">
            <button onClick={applyFilters} className="btn btn-primary">
              Buscar
            </button>
            <button onClick={resetFilters} className="btn btn-secondary">
              Limpiar Filtros
            </button>
            <button onClick={fetchData} className="btn btn-secondary">
              Actualizar Datos
            </button>
          </div>
        </div>

        {/* Configuración de Columnas */}
        <div className="columns-config">
          <h3>Configuración de Columnas:</h3>
          <div className="columns-toggle">
            {columns.map(col => (
              <label key={col.key} className="checkbox-label">
                <input
                  type="checkbox"
                  checked={col.visible}
                  onChange={() => toggleColumnVisibility(col.key)}
                />
                {col.label}
              </label>
            ))}
          </div>
        </div>

        {/* Tabla de Datos */}
        <div className="table-section protected-content no-select">
          {loading ? (
            <div className="loading">Cargando datos...</div>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  {visibleColumns.map((col, index) => (
                    <th 
                      key={col.key}
                      draggable
                      onDragStart={(e) => handleDragStart(e, columns.findIndex(c => c.key === col.key))}
                      onDragOver={(e) => handleDragOver(e, index)}
                      onDrop={(e) => handleDrop(e, index)}
                      onClick={() => handleSort(col.key)}
                      className={`sortable ${
                        col.key === 'CardCode' ? 'fixed-column' : 
                        col.key === 'CardName' ? 'fixed-column-2' : ''
                      }`}
                    >
                      {col.label}
                      {sortConfig.key === col.key && (
                        <span className="sort-indicator">
                          {sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}
                        </span>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    {visibleColumns.map(col => (
                      <td 
                        key={col.key}
                        className={
                          col.key === 'CardCode' ? 'fixed-column' : 
                          col.key === 'CardName' ? 'fixed-column-2' : ''
                        }
                      >
                        {item[col.key] || '-'}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          
          {!loading && filteredData.length === 0 && (
            <div className="no-data">No se encontraron resultados</div>
          )}
        </div>
      </div>
    </ContentProtector>
  );
};

export default DatosClientes;